import API from "@core/api/api";

export const fetchAllPickups = async (params) => {
  const response = await API.get(`/pickups?${params}`);
  return response.data;
};

// Alias for backward compatibility
export const getAllPickups = fetchAllPickups;

export const fetchPickupByID = async (pickupId) => {
  const response = await API.get(`/pickups/${pickupId}`);
  return response.data;
};

// Get pickup with full timeline details
export const getPickupWithTimeline = async (pickupId) => {
  const response = await API.get(`/pickups/${pickupId}`);
  return response.data;
};

// Get pickups for current collector
export const getCollectorPickups = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await API.get(`/pickups/collector/my-pickups?${queryString}`);
  return response.data;
};

// Update pickup status by collector
export const updatePickupStatusByCollector = async (id, statusData) => {
  const response = await API.put(`/pickups/${id}/collector-status`, statusData);
  return response.data;
};

// Get pickups for current livreur (DEPRECATED - use collector functions instead)
export const getLivreurPickups = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await API.get(`/pickups/livreur/my-pickups?${queryString}`);
  return response.data;
};

// Update pickup status by livreur (DEPRECATED - use collector functions instead)
export const updatePickupStatusByLivreur = async (id, statusData) => {
  const response = await API.put(`/pickups/${id}/livreur-status`, statusData);
  return response.data;
};

export const createPickup = async (pickup) => {
  const response = await API.post(`/pickups`, pickup);
  return response.data;
};

export const deletePickup = async (pickupId) => {
  const response = await API.delete(`/pickups/${pickupId}`);
  return response.data;
};

export const updatePickup = async ({ id, values }) => {
  const response = await API.put(`/pickups/${id}`, values);
  return response.data;
};

export const updatePickupStatus = async (id, data) => {
  const response = await API.put(`/pickups/${id}/status`, data);
  return response.data;
};

export const generateBonDeLivraison = async (id) => {
  const response = await API.post(`/pickups/${id}/pdf`);
  return response.data;
};

// ** ADMIN PICKUP ASSIGNMENT FUNCTIONS **

// Collector assignment functions (NEW)
export const assignCollectorToPickup = async (pickupId, data) => {
  const response = await API.put(`/pickups/${pickupId}/assign-collector`, data);
  return response.data;
};

export const unassignCollectorFromPickup = async (pickupId, reason = "") => {
  const response = await API.put(`/pickups/${pickupId}/unassign-collector`, {
    reason,
  });
  return response.data;
};

// Livreur assignment functions (DEPRECATED - use collector functions instead)
export const assignLivreurToPickup = async (pickupId, data) => {
  const response = await API.put(`/pickups/${pickupId}/assign-livreur`, data);
  return response.data;
};

export const unassignLivreurFromPickup = async (pickupId, reason = "") => {
  const response = await API.put(`/pickups/${pickupId}/unassign-livreur`, {
    reason,
  });
  return response.data;
};

// ** END ADMIN PICKUP ASSIGNMENT FUNCTIONS **
